module.exports = {
  "country": "SM",
  "artist": "Valentina Monetta",
  "song": "Maybe",
  "year": "2014",
  "place": "24",
  "spotify": "0fszknek4oiF2xdsbLNOqJ"
};